import React from "react";
import images from "../../images";

const QuestNearYou = ({
  title,
  locationNow,
  bizName,
  city,
  country,
  district,
}) => {
  return (
    <div className="flex flex-col items-start gap-[12px]">
      {/* <h5 className="text-[#253FF6] font-[Figtree] text-[20px] font-bold not-italic leading-none">
        {title}
      </h5> */}

      {bizName && (
        <p className="text-[#333] font-[Figtree] text-[20px] font-medium not-italic">
          {bizName}
        </p>
      )}

      <div className="flex flex-row gap-2 items-center">
        <img
          src={images.MapPinIcon}
          alt="map-pin-icon"
          className="h-[18px] w-[18px]"
        />
        <div className="text-[#A0A0A0] font-[Figtree] text-[16px] font-medium not-italic ">
          {locationNow && district && city && country ? (
            <span>
              {locationNow}, {district}, {city}, {country}
            </span>
          ) : (
            <span>Singapore</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default QuestNearYou;
